import { z } from 'zod';

import { WebappEnvSchema } from '../entities/webapp-env';

export const EnvSchema = z.object({
  VITE_WEBAPP_ENV: WebappEnvSchema,
  VITE_WEBAPP_RELEASE: z.string(),
  VITE_WEBAPP_BFF_URL: z.string().url(),
  VITE_SENTRY_ENABLE: z.any().transform((v) => v === 'true'),
  VITE_AUTH0_DOMAIN: z.string(),
  VITE_AUTH0_CLIENT_ID: z.string(),
  VITE_AUTH0_AUDIENCE: z.string(),
  VITE_POSTHOG_ENABLE: z.any().transform((v) => v === 'true'),
  VITE_POSTHOG_PUBLIC_KEY: z.string().optional(),
});

export type Env = z.infer<typeof EnvSchema>;
